import { useAuthMe } from './authMe';

// =============================================================================
// 현재 로그인 사용자의 이메일을 반환한다(소문자).
//   undefined → /me 조회 중(로딩)
//   string    → 로그인 이메일
//   null      → 미인증/로컬 dev/조회 실패
// 로딩과 "이메일 없음"을 구분해, 라우트 가드가 조회 완료 전 성급히 리다이렉트하지
// 않도록 한다.
// =============================================================================

export function useAuthEmail(): string | null | undefined {
  const { loading, me } = useAuthMe();
  if (loading) return undefined;
  return me?.email?.toLowerCase() ?? null;
}

// 캘리브레이션 진입 권한 — 지정 계정 전용. 단, 로컬 dev 모드(vite DEV)에서는
// 인증 스택 없이도 메뉴/라우트가 보이도록 항상 허용한다.
// 서버측 가드(env CALIBRATION_ADMIN_EMAILS 기본값)와 목록을 맞춰 유지할 것.
const CALIBRATION_ADMIN_EMAILS = [
  'beomseok.jang@hnine.com',
  'h9interaction@gmail.com',
];

export function useCanCalibrate(): { canCalibrate: boolean; loading: boolean } {
  const email = useAuthEmail();
  if (import.meta.env.DEV) return { canCalibrate: true, loading: false };
  return {
    canCalibrate: email != null && CALIBRATION_ADMIN_EMAILS.includes(email),
    loading: email === undefined,
  };
}
